import React, { useState } from "react";
import { Box, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";
import { schedulePalette } from "../components/PageLayout";
import { useBranding } from "../contexts/BrandingContext";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function MainLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { branding } = useBranding();
  const layoutMode = branding.layout || "SIDEBAR";
  const showSidebar = layoutMode === "SIDEBAR" && branding.sidebarEnabled !== false;
  const showTopNav = layoutMode === "TOP_NAV";
  const compactLayout = layoutMode === "MINIMAL";
  const wideLayout = layoutMode === "TWO_COLUMN";

  const toggleMobileDrawer = () => {
    setMobileOpen((prev) => !prev);
  };

  const closeMobileDrawer = () => {
    setMobileOpen(false);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {showSidebar ? <Sidebar mobileOpen={mobileOpen} onClose={closeMobileDrawer} /> : null}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          color: "text.primary",
          background: "var(--app-page-shell-gradient, linear-gradient(180deg, rgba(214, 234, 248, 0.55) 0%, rgba(241, 245, 249, 0.96) 26%, rgba(255, 255, 255, 1) 100%))",
          minWidth: 0,
        }}
      >
        <Topbar onMenuClick={toggleMobileDrawer} showMenuButton={showSidebar} layoutMode={layoutMode} />
        <Box sx={{ height: showTopNav ? 112 : 64 }} />
        <Box
          sx={{
            px: "var(--app-content-padding-x, 24px)",
            py: "var(--app-content-padding-y, 24px)",
            maxWidth: compactLayout ? 1100 : wideLayout ? 1440 : "var(--app-content-max-width, 100%)",
            mx: compactLayout ? "auto" : 0,
            width: "100%",
            minHeight: "calc(100vh - 64px)",
            borderTop: `1px solid ${schedulePalette.border}`,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
